// TableComponent.jsx
import React, { useEffect, useState } from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { useSelector } from "react-redux";

const AlertTable = () => {
  const [data, setData] = useState([]);

  const heatData = useSelector((state) => state.deviceConfig.heatData);
  const deviceData = useSelector((state) => state.deviceConfig.deviceData);

  // Jab "Clear Device" dabaya jaye (deviceData false ho jaye), table bhi khali kardo
  useEffect(() => {
    if (!deviceData) {
      setData([]);
    }
  }, [deviceData]);

  // Naya row sirf tab add karo jab timestamp pichle wale se alag ho
  useEffect(() => {
    if (heatData) {
      setData((prevData) => {
        const lastEntry = prevData[prevData.length - 1];
        if (!lastEntry || lastEntry.timestamp !== heatData.timestamp) {
          return [...prevData, heatData];
        }
        return prevData; // same timestamp -> duplicate mat dikhao
      });
    }
  }, [heatData]);

  return (
    <MDBox sx={{ padding: 2 }}>
      <Box
        sx={{
          maxHeight: 700,
          overflowY: "auto",
          "&::-webkit-scrollbar": { width: "6px" },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#c0c0c0",
            borderRadius: "3px",
          },
          "&::-webkit-scrollbar-track": { backgroundColor: "#f0f0f0" },
        }}
      >
        <Table>
          <TableHead sx={{ display: "table-header-group" }}>
            <TableRow display="table-header-group">
              <TableCell>
                <MDTypography variant="subtitle2" fontWeight="bold">
                  Timestamp
                </MDTypography>
              </TableCell>
              <TableCell>
                <MDTypography variant="subtitle2" fontWeight="bold">
                  Alert
                </MDTypography>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.length === 0 ? (
              <TableRow>
                <TableCell colSpan={2} align="center">
                  <MDTypography variant="body1" color="text.secondary">
                    No Data
                  </MDTypography>
                </TableCell>
              </TableRow>
            ) : (
              data.map((row, index) => (
                <TableRow key={index}>
                  <TableCell>
                    <MDTypography variant="body2" sx={{ wordBreak: "break-word" }}>
                      {new Date(row.timestamp).toLocaleString()}
                    </MDTypography>
                  </TableCell>
                  <TableCell>
                    <MDTypography variant="body2" sx={{ wordBreak: "break-word" }}>
                      {row.rawdata}
                    </MDTypography>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </Box>
    </MDBox>
  );
};

export default AlertTable;